module.exports = __webpack_public_path__ + "img/mo.44f9c55.svg";